import {isOnscreen, elementExists, slideDown, slideUp, isTabletMobile} from '../Helpers/Helper.js';

class Common {

    openModal() {
        const $this = this;
        const modalOverlay = document.getElementById('modal-overlay');
        const modalTriggers = document.querySelectorAll('.bol-modal-trigger');
        const page = document.getElementById('page');
        elementExists(modalTriggers).then(value => value ? () => {
            modalTriggers.forEach((trigger) => {
                trigger.onclick = function () {
                    let modalId = trigger.getAttribute('data-modal-id');
                    let formId = trigger.getAttribute('data-form-id');
                    let modal = document.getElementById(modalId);
                    modalOverlay.innerHTML = modal.innerHTML;
                    const close = modalOverlay.querySelector('.close');
                    close.addEventListener('click', () => {
                        $this.closeModal(modalOverlay);
                    });
                    setTimeout(() => {
                        modalOverlay.classList.add('modal-visible');
                        page.classList.add('blur-it');
                        if (formId) {
                            $this.initForm(formId);
                        }
                    }, 300);
                };
            });
        } : () => {
            return false;
        }).then(value => value());
    }

    triggerClose() {
        const $this = this;
        const modalOverlay = document.getElementById('modal-overlay');
        elementExists(modalOverlay).then(value => value ? () => {
            modalOverlay.addEventListener('click', event => !event.target.closest('.modal-content') ? $this.closeModal(modalOverlay) : null);
            window.addEventListener('keydown', event => event.key === 'Escape' ? $this.closeModal(modalOverlay) : null);
        } : () => {
            return false;
        }).then(value => value());
    }

    closeModal(modal) {
        modal.classList.remove('modal-visible');
        document.getElementById('page').classList.remove('blur-it');
        setTimeout(() => {
            modal.innerHTML = '';
        }, 500);
    }

    handleMenuOpenMobile() {
        const menuToggler = document.querySelector('.navbar-toggler');
        const menuHolder = document.querySelector('.navbar-collapse');
        const mainMenu = document.getElementById('main-menu');
        const subMenuWithChildren = mainMenu.querySelectorAll('.menu-item-has-children');
        if (menuToggler !== null && menuToggler !== 'undefined') {
            menuToggler.addEventListener('click', e => {
                e.preventDefault();
                e.stopImmediatePropagation();
                menuToggler.classList.toggle('open');
                if (menuHolder !== null && menuHolder !== 'undefined') {
                    menuHolder.classList.toggle('collapse');
                }

                [...subMenuWithChildren].forEach(item => {
                    const subMenu = item.querySelector('.dropdown-menu');
                    subMenu.classList.add('collapse');
                    slideUp(subMenu);
                });
            });
        }
    }

    filterPosts() {
        jQuery(document).ready(function ($) {
            const ajaxurl = myAjax.ajaxurl;

            // Cache to store responses for each category
            const categoryCache = {};

            // Load the latest posts for "Me te lexuara" category by default
            $('.category-btn[data-category="me-te-lexuara"]').addClass('active');
            const defaultCategory = $('.category-btn.active').data('category');
            $('.posts-container').load(
                ajaxurl,
                {
                    action: 'get_latest_posts',
                    category: defaultCategory,
                },
                function(response) {
                    categoryCache[defaultCategory] = response;
                }
            );

            // Load the latest posts for the clicked category without refreshing the page
            $('.categories').on('click', '.category-btn', function (event) {
                event.preventDefault();
                const category = $(event.currentTarget).data('category');
                $('.category-btn').removeClass('active');
                $(event.currentTarget).addClass('active');

                if (categoryCache[category]) {
                    $('.posts-container').html(categoryCache[category]);
                } else {
                    $('.posts-container').load(
                        ajaxurl,
                        {
                            action: 'get_latest_posts',
                            category: category,
                        },
                        function(response) {
                            categoryCache[category] = response;
                        }
                    );
                }
            });
        });
    }

    searchIcon() {
        // Add this to your JavaScript code
        const searchIcon = document.querySelector('#search-icon');
        const searchOverlay = document.querySelector('#search-overlay');

        searchIcon.addEventListener('click', () => {
            searchOverlay.style.display = 'block';
        });

        searchOverlay.addEventListener('click', (event) => {
            if (event.target === searchOverlay) {
                searchOverlay.style.display = 'none';
            }
        });
    }

    searchClose() {
        /* Add this to your JavaScript code */
        const searchIcon = document.getElementById('search-icon');
        const searchOverlay = document.getElementById('search-overlay');
        const searchClose = document.getElementById('search-close');

        searchIcon.addEventListener('click', function () {
            searchOverlay.style.display = 'block';
        });

        searchClose.addEventListener('click', function () {
            searchOverlay.style.display = 'none';
        });

    }

    moreCategory(){
        jQuery(document).ready(function($) {
            $.ajax({
                url: myAjax.ajaxurl,
                type: 'POST',
                data: {
                    action: 'get_latest_posts',
                    category: 'your-category-slug'  // replace with your category slug
                },
                success: function(response) {
                    // Do something with the response
                    console.log(response);
                },
                error: function(error) {
                    // Log any errors
                    console.log('Error: ', error);
                }
            });
        });

    }


    init() {

        this.filterPosts();
        this.moreCategory();
        this.openModal();
        this.searchClose();
        this.searchIcon();
        this.triggerClose();
        this.handleMenuOpenMobile();

        document.querySelectorAll('.bol-block').forEach((el) => {
            window.addEventListener(
                'scroll',
                () => {
                    if (isOnscreen(el) && !el.classList.contains('bol-block-visible')) {
                        el.classList.add('bol-block-visible');
                    }
                },
            );
        });
    }
}

const singleton = new Common();

export function init() {
    singleton.init();
}
